import { CSSProperties, memo } from "react";
import { ExpandingTooltipReturn } from "../hooks/useAdvancedTooltip";
import "../../styles/circles.css";

type Props = {
  length: number;
  style?: CSSProperties;
  tProps?: ExpandingTooltipReturn["triggerProps"];
};

const SizeBubble = (props: Props) => {
  return (
    <span
      {...props.tProps}
      className={`circle ${props.length == 0 ? "warning" : ""}`}
      style={props.style}
    >
      {props.length <= 0 ? "None" : props.length}
    </span>
  );
};

const MemoSizeBubble = memo(SizeBubble);
export { MemoSizeBubble as SizeBubble };
